import React from "react"
import PropTypes from "prop-types"

import Header from "../header/header"
import Title from "../title/title"
import Footer from "../footer/footer"

const Main = ({ children }) => {
    return (
        <>
            <Header/>
            <Title/>
            <div className={"sr-main"}>{children}</div>
            <Footer/>
        </>
    )
}

Main.propTypes = {
    children: PropTypes.node.isRequired,
}

export default Main
